// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nav_setupClient__2HPuk {\n  justify-content: space-between !important;\n}\n", "",{"version":3,"sources":["webpack://src/components/navbar/nav.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;AAC3C","sourcesContent":[".setupClient {\n  justify-content: space-between !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"setupClient": "nav_setupClient__2HPuk"
};
export default ___CSS_LOADER_EXPORT___;
